import { Button, Modal } from '@clearcover/atlas';
import { PolicyHolderType } from '@clearcover/core-app-types';
import React, { FC, useContext } from 'react';
import { combineStrings, EMDASH, formatPhoneNumber } from 'Shared/utils';

import { Card, CardHeader } from 'Shared/components';
import { EditAccountForm } from './EditAccountForm';
import styles from './styles.module.css';

import { editPolicyContactInfoPolicy } from 'Admin/authPolicies';
import { PolicyContext } from 'Policies/utils';
import { CardDataSection } from 'Shared/components/Card/CardDataSection';
import { CardSectionInfoPairs } from 'Shared/components/Card/CardSectionInfoPairs';
import { useModalHashChange } from 'Shared/hooks';

type PolicyDetailSectionTypes = {
  policyHolder?: PolicyHolderType;
};

export const PolicyAccountSection: FC<PolicyDetailSectionTypes> = ({
  policyHolder,
}) => {
  const { systemOfRecord, resourceEffectiveGrants, loading } = useContext(
    PolicyContext
  );
  const { modalHashChange } = useModalHashChange('editAccountDetails');

  const canEditPolicyContactInfo =
    systemOfRecord === 'clearcover' &&
    editPolicyContactInfoPolicy(resourceEffectiveGrants);

  return (
    <Card id="policy-account-card">
      <CardHeader title="Account Details">
        {policyHolder && canEditPolicyContactInfo && (
          <Modal
            onVisibilityChange={modalHashChange}
            variant="full"
            toggle={openModal => (
              <Button
                className={styles.editAccountButton}
                size="sm"
                variant="secondary"
                onClick={openModal}
                data-testid="open-edit-account-modal"
              >
                <span>Edit</span>
              </Button>
            )}
          >
            {close => (
              <EditAccountForm policyHolder={policyHolder} close={close} />
            )}
          </Modal>
        )}
      </CardHeader>
      <CardDataSection
        className={styles.contactInfo}
        caption="Contact Info"
        id="contact-info"
      >
        <CardSectionInfoPairs
          dataFontStyle="none"
          headers={[
            'Policy Holder',
            'Home Phone',
            'Cell Phone',
            'Email Address',
          ]}
          data={
            policyHolder && !loading
              ? [
                  combineStrings([
                    policyHolder.name.firstName,
                    policyHolder.name.lastName,
                    policyHolder.name.suffix,
                  ]),
                  policyHolder.contactInfo.homePhone
                    ? formatPhoneNumber(policyHolder.contactInfo.homePhone)
                    : EMDASH,
                  policyHolder.contactInfo.cellPhone
                    ? formatPhoneNumber(policyHolder.contactInfo.cellPhone)
                    : EMDASH,
                  policyHolder.contactInfo.email,
                ]
              : Array(4).fill('')
          }
          loading={loading}
        />
      </CardDataSection>
    </Card>
  );
};
